import { SystemField } from "./system-field";

export class ProductWarehouseDetail extends SystemField {
     
     code?:string;
     is_active?:number;
     note?:string;
     products_id?:string;
     trans_type?:string;
     warehouses_id?:string;
     location_id?:string;
     uom?:string;
     is_default?:number;
}
